export default __webpack_public_path__ + "static/media/rejudge-icon.49d3565a.svg";